import billingModule from '../../billing.module';
import template from './billingModalPaymentForm.component.html';
import style from './billingModalPaymentForm.component.css';

export default billingModule.component('billingModalPaymentForm', {
    template,
    style,
    bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '<',
        resolve: '<'
    },
    controller(
        $q,
        $scope,
        $window,
        asNotifier,
        billingPaymentService,
        textResources
    ) {
        var vm = this;

        vm.$onInit = () => {
            $window.addEventListener('message', event => {
                if (/zuora\.com$/i.test(event.origin)) {
                    vm.isRendering = false;
                    $scope.$apply();
                }
            });

            vm.render();
        };

        vm.callback = response => {
            if (!response.responseFrom) {
                asNotifier.error(
                    `${textResources.genericError} ${
                        textResources.ifProblemPersists
                    }`
                );
                vm.dismiss();

                return;
            }

            if (response.responseFrom == 'Response_From_Request_Page') {
                if (!response.success) {
                    asNotifier.error(response.errorMessage);
                    vm.dismiss();
                }

                return;
            }

            if (response.responseFrom == 'Response_From_Submit_Page') {
                if (response.success == 'true') {
                    vm.close({
                        $value: {
                            ...vm.resolve,
                            paymentMethodId: response.refId
                        }
                    });
                } else {
                    asNotifier.errorAndTryAgain(
                        textResources.billingUpdatePaymentMethodFailed
                    );
                    vm.dismiss();
                }
            }
        };

        vm.render = () => {
            vm.isRendering = true;

            $q.all([
                billingPaymentService.getClientApi(),
                billingPaymentService.getPaymentMethodFormConfiguration()
            ]).then(
                data => {
                    var clientApi = data[0];
                    var formConfig = data[1];

                    clientApi.payments.render(
                        formConfig.params,
                        formConfig.prepopulateFields,
                        response => vm.callback(response)
                    );
                },
                () => {
                    asNotifier.error(
                        `${textResources.genericError} ${
                            textResources.ifProblemPersists
                        }`
                    );
                }
            );
        };

        vm.submit = () => {
            billingPaymentService.getClientApi().then(
                clientApi => {
                    clientApi.payments.submit();
                },
                () => {
                    asNotifier.error(
                        `${textResources.genericError} ${
                            textResources.ifProblemPersists
                        }`
                    );
                }
            );
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-modal-payment-form/billingModalPaymentForm.component.js